import { Redirect, Route, RouteProps } from "react-router-dom";
import { useAuth } from "../../contexts/authContext";

export const PrivateRoute = ({ children, ...rest }: RouteProps) => {
  const auth = useAuth();
  return (
    <Route
      {...rest}
      render={() => (
        <>
          {auth.isAuthenticated ? (
            children
          ) : (
            <Redirect to={{ pathname: "/login" }} />
          )}
        </>
      )}
    />
  );
};
